// rsvp strings (en).
const rsvp = {
	rsvp: {
		going: 'Going',
		maybe: 'Maybe',
		cantGo: "Can't go",
		respondPrompt: 'Will you be there?',
		guests: 'Additional guests',
		guestsLabel: 'Number of additional guests',
		note: 'Note for the host (optional)',
		notePlaceholder: 'Add a note',
		save: 'Save response',
		saving: 'Saving...',
		thanks: 'Thanks, your response is saved.',
		change: 'Change response',
		useYourLink: 'Open your personal invitation link to respond.',
		joinOnline: 'Join online',
		addToCalendar: 'Add to calendar',
		googleCalendar: 'Google Calendar',
		appleOutlook: 'Apple / Outlook (.ics)',
		error: 'Something went wrong. Please try again in a moment.',
		invalid: 'Please check your response and try again.',
		notFound: 'This invitation could not be found.',
		hostNote: 'Note from the host',
		decrease: 'Remove one guest',
		increase: 'Add one guest',
		yourResponse: 'Your response',
		dashboard: {
			tab: 'RSVPs',
			noReply: 'No reply',
			plusGuests: { one: '+{{count}} guest', other: '+{{count}} guests' },
			all: 'All',
			filter: 'Filter by response',
			export: 'Export CSV',
			name: 'Name',
			email: 'Email',
			response: 'Response',
			guestsCol: 'Guests',
			noteCol: 'Note',
			updated: 'Updated',
			empty: 'No recipients yet',
			loading: 'Loading RSVPs...',
			forbidden: 'You are not allowed to view RSVPs for this card.',
			error: 'Could not load RSVPs. Please try again.',
			noMatches: 'No recipients match this filter',
			summary: 'RSVP summary',
		},
	},
};

export default rsvp;
